import UpdaterBase from "./base/updater-base";

export default class BlankUpdater extends UpdaterBase {
    // eslint-disable-next-line no-unused-vars
    update(display) {
    }
}